import { View } from "@/components/ui/view";
import React, { useCallback, useEffect, useState, useContext } from 'react';
import { useSelector, useDispatch } from 'react-redux'
import app from '../app.json'
import * as SplashScreen from 'expo-splash-screen';
import { useFonts } from 'expo-font';
import {
  Assistant_200ExtraLight,
  Assistant_300Light,
  Assistant_400Regular,
  Assistant_500Medium,
  Assistant_600SemiBold,
  Assistant_700Bold,
  Assistant_800ExtraBold
} from '@expo-google-fonts/assistant';

import { GlobalState } from '../containers/GlobalState';
import Main from "./Main";
import Studio from '../studio/containers/Studio';
import { migrate, reset, wsConnect, setBackend } from "../stores/mainSlice";

// TODO: Check if repeatable
// To locate the bad setState() call inside `Loader`, follow the stack trace as described in https://reactjs.org/link/setstate-in-render
export default function Loader() {
  const latest = '3.6.4'
  const { guid7, isWeb } = useContext(GlobalState)

  const dispatch = useDispatch()
  const version = useSelector((state) => state.version)
  const legal = useSelector((state) => state.legal)
  const server = useSelector((state) => state.server)
  const user = useSelector((state) => state.user)
  const url = isWeb ? new URL(window.location) : null
  const [showApp, setShowApp] = useState(!isWeb || (url.origin == 'https://app.ina.coach' || url.search && url.search.includes('app=1')))

  useEffect(() => {
    // console.log('XXX', server.url)
    // dispatch(setBackend({ url: 'http://localhost:3000' }))
    console.ina(isWeb ? url.origin + ' version' : 'App version:', app.expo.version)
    console.ina('State version:', version, version == latest, legal?.dpa_de?.version)
    // development hack to force initialState to be reloaded: change version here and in stores/mainSlice.js
    // dispatch(reset());

    if (version && version != latest) {
      // migrate existing state to current App level
      dispatch(migrate({ version: latest }));
    }
  }, [])

  const [fontsLoaded] = useFonts({
    Assistant_200ExtraLight,
    Assistant_300Light,
    Assistant_400Regular,
    Assistant_500Medium,
    Assistant_600SemiBold,
    Assistant_700Bold,
    Assistant_800ExtraBold
  })

  useEffect(() => {
    // console.ina('WS STATE', Date.now(), server?.ws, user)
    if (!user.demo) {
      if (server.online && server.ws && !server.ws.connected && !server.ws.connecting && server.ws.retries > 0) {
        dispatch(wsConnect({ uuid: guid7(), reconnect: server.ws.id != undefined }))
      }
    }
  }, [server.online, server.ws?.connected])

  const onLayoutRootView = useCallback(async () => {
    if (fontsLoaded) {
      try {
        await SplashScreen.hideAsync();
        console.ina('LOAD Hide', Date.now())
      } catch (error) {
        console.warn('LOAD Hide X', Date.now())
      }
    }
  }, [fontsLoaded]);

  if (!fontsLoaded) {
    return null
  }
  const webProps = showApp && isWeb ? { maxWidth: 390, width: '100%', maxHeight: 844, height: '100%', margin: 'auto', overflow: 'hidden' } : {}
  return <View onLayout={onLayoutRootView} {...webProps} className="flex-1">{showApp ? <Main /> : <Studio />}</View>;
}
